export default __webpack_public_path__ + "static/therapy-1c3fb8cceef131485775fe4fb1c1ee4b.svg";